import {DependencyList, useEffect} from "react";

type LifecycleController = {
    onMount?: () => void;
    onUnmount?: () => void;
};


export const useStoreLifecycle = (
    store: LifecycleController,
    deps: DependencyList = []
) => {
    useEffect(() => {
        store.onMount?.();

        return () => {
            store.onUnmount?.();
        };
    }, deps);
};